import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class BiddingOrdersService {

    constructor(private _http: HttpClient) { }

    getbidorders(data) {
        return this._http.post(environment.api_url+'/seller/bids/orders/byproduct',data);
    }

}
